import { BlockProps } from "../../blocks/types";
import React from "react";
import { BlockPanelProps } from "../register-block";

const BlockPropsContext = React.createContext<BlockProps>({} as BlockProps);

export function useBlockPanelPropsContext<T extends BlockProps = BlockProps>() {
  const context = React.useContext(BlockPropsContext);

  if (!context) {
    throw new Error(
      "useBlockPropsContext must be used within a BlockPropsContext.Provider",
    );
  }

  return context as BlockPanelProps<T>;
}

export default function PanelContainer({
  children,
  blockProps,
}: {
  children: React.ReactNode;
  blockProps: BlockProps;
}) {
  return (
    <BlockPropsContext.Provider value={blockProps}>
      {children}
    </BlockPropsContext.Provider>
  );
}
